import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Combines conditional classes and tailwind-merge for proper Tailwind class merging
 */
export function cn(...inputs: (string | undefined | null | boolean)[]) {
  const filtered = inputs.filter(Boolean) as string[];
  return twMerge(filtered.join(' '));
}

/**
 * Create consistent spacing classes
 */
export const spacing = {
  xs: 'p-1',
  sm: 'p-2', 
  md: 'p-4',
  lg: 'p-6',
  xl: 'p-8',
  '2xl': 'p-12',
  '3xl': 'p-16',
  '4xl': 'p-24',
  '5xl': 'p-32',
} as const;

/**
 * Create consistent margin classes
 */
export const margin = {
  xs: 'm-1',
  sm: 'm-2',
  md: 'm-4', 
  lg: 'm-6',
  xl: 'm-8',
  '2xl': 'm-12',
  '3xl': 'm-16',
  '4xl': 'm-24',
  '5xl': 'm-32',
} as const;

/**
 * Create consistent text size classes
 */
export const textSize = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl',
  '4xl': 'text-4xl',
  '5xl': 'text-5xl',
  '6xl': 'text-6xl',
} as const;

/**
 * Create consistent font weight classes
 */
export const fontWeight = {
  thin: 'font-thin',
  extralight: 'font-extralight',
  light: 'font-light',
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
  extrabold: 'font-extrabold',
  black: 'font-black',
} as const;

/**
 * Create consistent border radius classes
 */
export const borderRadius = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  base: 'rounded',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  '3xl': 'rounded-3xl',
  full: 'rounded-full',
} as const;

/**
 * Create consistent shadow classes
 */
export const shadow = {
  sm: 'shadow-sm',
  base: 'shadow',
  md: 'shadow-md',
  lg: 'shadow-lg',
  xl: 'shadow-xl',
  '2xl': 'shadow-2xl',
  inner: 'shadow-inner',
  none: 'shadow-none',
} as const;
